// extracted by mini-css-extract-plugin
module.exports = {"component":"SeoContent_component__Qj5Pb"};